import React from "react"
import { Alert, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { spacings } from "themes/variables"

export const StripeExpressMigrationBanner = () => {
  const { t } = useTranslation()

  return (
    <Alert
      className="mt-m"
      type="info"
      showIcon
      message={t("pro.personal_info.stripe.migration_banner.title")}
      description={
        <Flex vertical gap={spacings.XXS}>
          <span>{t("pro.personal_info.stripe.migration_banner.description")}</span>
          <ul>
            <li>{t("pro.personal_info.stripe.migration_banner.benefit_dashboard")}</li>
            <li>{t("pro.personal_info.stripe.migration_banner.benefit_direct_charge")}</li>
          </ul>
          <span>{t("pro.personal_info.stripe.migration_banner.how_to_migrate")}</span>
        </Flex>
      }
    />
  )
}
